import BaseAPI from '../BaseAPI';

/**
 * Api class for handling the user's trusted devices
 */
class UserDevices extends BaseAPI {
  /**
   * Creates UserDevices instance
   *
   * @param props {Object}
   * @return {UserDevices}
   */
  constructor(props) {
    super(props);

    this.baseUrl = '/users/devices';
  }

  /**
   * Fetch the trusted devices list
   *
   * @returns {Promise<*|Error>}
   */
  fetchDevices() {
    const url = `${this.baseUrl}`;

    return this.get({ url });
  }

  /**
   * Remove a trusted device; it will require OTP verification at its next login
   *
   * @param id {number}
   * @returns {Promise<*|Error>}
   */
  removeDevice(id) {
    const url = `${this.baseUrl}/${id}`;

    return this.remove({ url });
  }
}

export default UserDevices;
